import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Link } from '@change/ds-core-ui';

import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { usePetitionQRCode } from 'src/app/shared/hooks/qrcode';

type PetitionQRCodeDownloadLinkProps = PropsWithChildren<{
	slugOrId: string;
	type: QrCodeType;
	size: number;
	filename?: string;
	onClick?: () => Promise<void>;
}>;

export const PetitionQRCodeDownloadLink: React.FC<PetitionQRCodeDownloadLinkProps> = ({
	children,
	slugOrId,
	size,
	type,
	filename,
	onClick,
}) => {
	const { data } = usePetitionQRCode({ slugOrId, size, type, adjustForPixelRatio: false });

	const handleDownload = async () => {
		await onClick?.();
	};

	return (
		<Link
			href={data?.imageBase64Uri ?? '#'}
			download={filename || true}
			onClick={handleDownload}
			bold
			variant="secondary"
			data-qa="qrcode-download-link"
			data-testid="qrcode-download-link"
		>
			{children}
		</Link>
	);
};
